export const dropHeader = {
    title: {
        ru: 'Airdrop',
        en: 'Airdrop'
    },

}
